import styled from 'styled-components';
import { Button, Card, Typography } from '@mui/material';
import { useSnackbar } from "notistack";
import { IconPhoto } from '@tabler/icons-react';

import { CustomUploadPhotoInterface } from '../../../Models/Common/CustomViewsInterfaces';

import LocalStorageHelper from '../../../Utilities/Helpers/LocalStorageHelper';

import { ViewType } from '../../../Utilities/Enums/ViewTypeEnum';
import { ImageFileField } from '../../../Utilities/Enums/ParametersEnum';

import { ErrorMessage } from '../../../Constants/Messages';
import { AssetImages } from '../../../Constants/Assets';

const CustomUploadPhotoContainer = styled(Card) <{ $darkMode?: boolean; }>`
	// background: transparent !important;
    box-shadow: none !important;
    border: none !important;
    border-radius: 0px !important;
    display: flex;
    justify-content: space-between;
    align-items: center !important;
    overflow: unset !important;

    .sideTitlesContainer {
		margin: 0px 0px 0px 20px;
    }

    .sideTitle {
        font-weight: 600;
        font-size: 18px;
		margin: 0px 0px 10px 0px;
		// text-transform: uppercase;
		text-align: left;
    }

    .sideSubTitle {
        font-weight: 500;
        font-size: 0.825rem;
		color: #878a99 !important;
		text-align: left;
    }
`;

const PhotoPickerContainer = styled(Card) <{ $darkMode?: boolean; }>`
	// background: transparent !important;
    box-shadow: none !important;
    border: solid 1px;
    border-radius: 10px !important;

    position: relative;
	display: inline-block;
	float: left;
	overflow: unset !important;

	.imgPickerContainer {
		width: 100%;
		margin: 0px;

		.imgContainer {
			width: 110px;
			height: 110px;
			border-radius: 10px;
			overflow: hidden;
			padding: 10px;
			display: block;

			.imgContent {
				object-fit: cover;
				width: 100%;
				height: 100%;
				border-radius: 10px;
			}
		}

		.uploadImgBtn {
			background: ${(props) => props.$darkMode ? '#1d2021' : '#f3f6f9'} !important;
			width: 30px !important;
			height: 30px !important;
			min-width: unset;
			padding: 4px 7px;
			border-radius: 30px;
			display: block;
			position: absolute;
			border: solid 1px;
			border-color: ${(props) => props.$darkMode ? '#ffffff1f' : '#0000001f'} !important;
			box-shadow: none;
			right: -5px;
			bottom: -5px;
			.uploadImgBtnIcon {
				margin: 0px;
				padding: 0px;
				width: 100%;
				height: 100%;

				fill: #878a99;
			}
		}
	}
`;

export default function CustomUploadPhoto(fieldProps: CustomUploadPhotoInterface) {
	//Variables
	const { enqueueSnackbar } = useSnackbar();
	let { photoParams, editPhotoParams, seteditPhotoParams, viewType, sideTitle, sideSubTitle } = fieldProps;
	let dImg = viewType == ViewType.PREVIEW ? photoParams?.[ImageFileField.VIEW_IMAGE] ?? AssetImages.USER_DEFAULT_PIC : editPhotoParams?.[ImageFileField.VIEW_IMAGE] ?? AssetImages.USER_DEFAULT_PIC;

	//Event Handler
	const handleCapture = (event: any) => {
        if (event.target.files.length > 0) {
            const fileReader = new FileReader();
            const acceptedFileTypes: any = ['image/apng', 'image/avif', 'image/gif', 'image/jpeg', 'image/png', 'image/svg+xml', 'image/webp'];
            let _proceed = false;

            if(acceptedFileTypes != null && acceptedFileTypes != "" && acceptedFileTypes.length > 0) {
                _proceed = (event.target.files[0] && event.target.files[0].type && event.target.files[0].type != null && event.target.files[0].type != "" && acceptedFileTypes.includes(event.target.files[0].type) ? true : false);
            }

            if(_proceed) {
	            fileReader.readAsDataURL(event.target.files[0]);
	            fileReader.onload = (e: any) => {
	            	if(seteditPhotoParams) {
		                seteditPhotoParams((prev: any) => ({
		                    ...prev,
		                    [ImageFileField.IMAGE_FILE]: event.target.files[0],
		                    [ImageFileField.VIEW_IMAGE]: e.target.result,
		                }));
		            }
	            };
	        } else {
	        	enqueueSnackbar(ErrorMessage.INVALID_FILE_FORMAT, { variant: 'error'});
	        }
        }
    };

    //Rendering Functions
    return <CustomUploadPhotoContainer>
	    <PhotoPickerContainer $darkMode={(LocalStorageHelper.isDarkMode() ? LocalStorageHelper.isDarkMode() : false)} sx={{borderColor: 'customBorder.main', backgroundColor: 'customBackground.main'}}>
	        <div className="imgPickerContainer">
	            <div className="imgContainer">
	                <img className="imgContent" src={dImg} />
	            </div>
	            { viewType != ViewType.PREVIEW && <Button
	                className="uploadImgBtn"
	                variant="contained"
	                component="label" >
	                    <div className="uploadImgBtnIconContainer">
	                        <IconPhoto className="uploadImgBtnIcon" />
	                    </div>
	                    <input
	                        type="file"
	                        className="profileImage"
	                        onChange={handleCapture}
	                        hidden />
	                </Button> }
	        </div>
	    </PhotoPickerContainer>
	    <div className="sideTitlesContainer">
		    {sideTitle && <Typography color="primaryText" className="sideTitle">{sideTitle ?? ""}</Typography>}
		    {sideSubTitle && <Typography className="sideSubTitle">{sideSubTitle ?? ""}</Typography>}
		</div>
    </CustomUploadPhotoContainer>
}
